'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroLinks = require('./NitroLinks');

var _NitroLinks2 = _interopRequireDefault(_NitroLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroLinks2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-links/index.js
// module id = 505
// module chunks = 4